module.exports = __webpack_public_path__ + "static/media/default_img.07df7e5f.png";